/**
 * @fileoverview プロパティ表示コンポーネント
 *
 * このファイルでは、キーと値のペアをラベル付きで表示するための
 * 再利用可能なコンポーネントを定義しています。ユーザー情報や設定項目などの
 * 表示に使用されます。
 */

/**
 * プロパティコンポーネント
 *
 * キーと値のペアを整形されたフォーマットで表示します。
 * ラベル（キー）とその値を視覚的に区別しやすいレイアウトで提供し、
 * 情報の閲覧性を高めます。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.label - プロパティのラベル（キー）
 * @param {React.ReactNode} props.value - 表示する値
 * @param {string} [props.className] - 追加のCSSクラス名
 * @returns {JSX.Element} プロパティ表示コンポーネント
 */
import { FC, ReactNode } from "react";

import { Group, Text } from "@mantine/core";

import { Path, Link } from "@/router";

export type PropertyType = {
  key: string;
  value: string | ReactNode;
  link?: { label: string; to: Path };
};

type Props = {
  property: PropertyType;
};

export const Property: FC<Props> = ({ property }) => {
  return (
    <td className="w-screen">
      <Text className="text-gray-500">{property.key}</Text>
      {typeof property.value === "object" ? (
        property.value
      ) : (
        <Group className="justify-between">
          <Text className="text-lg">{property.value}</Text>
          {property.link ? (
            <Link to={property.link.to}>
              <Text className="text-blue-600 hover:text-blue-700">
                {property.link.label}
              </Text>
            </Link>
          ) : null}
        </Group>
      )}
    </td>
  );
};
